/**
 * 运行时页面配置缓存的统一 key
 *
 * 注意: master 视为默认分支, 不追加分支后缀, 需与服务端直出缓存(modules/html.js)的
 * 注入逻辑及 store/loaders 的读写保持一致, 否则非 master 分支会缓存 miss 并被迫
 * 走客户端请求(在 wujie 等跨域嵌入场景下会导致页面渲染失败)。
 */
export const getPageMapKey = ({ projectId, pageId, env, branch }) => `${projectId}:${pageId}:${env}${branch && branch !== 'master' ? `:${branch}` : ''}`;
